"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Socials = exports.DetailsImageViewport = exports.DetailsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
exports.DetailsContainer = styled_components_1.default.div(({ theme }) => theme.shareForm.detailsContainer);
exports.DetailsImageViewport = styled_components_1.default.figure(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.shareForm.detailsImage), { img: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
    } })));
exports.Socials = styled_components_1.default.div(({ theme }) => (Object.assign({ display: 'flex' }, theme.shareForm.detailsSocials)));
//# sourceMappingURL=fdr-share-details.styles.js.map